<template>
  <div class="contents">
    <MONav></MONav>
    <div style="padding-left:1%;">
      <div class="select-block">
        <div class="cross_title">
          <p class="titles"><span></span>农忙期间域外作业机具数</p>
          <div class="gutter-examples" v-show="njShow">
            <div class="gutter-boxs">
              <p class="tit">机具总数（台）</p>
              <p class="tit-num">{{ njTotal }}</p>
            </div>
            <div
              class="gutter-boxs"
              v-for="(item, index) in itemList"
              :key="index"
            >
              <p class="tit">{{ item.catName }}（台）</p>
              <p class="tit-num">{{ item.nums }}</p>
            </div>
          </div>
        </div>
        <el-form :inline="true" :model="formInline" class="demo-form-inline">
          <el-form-item v-if="this.$store.state.info.provCode === '31'">
            <el-select
              placeholder="请选择区"
              v-model="search.countyCode"
              style="width: 150px"
              clearable
            >
              <el-option
                v-for="(item, index) in countyList"
                :key="index"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-select
              placeholder="请选择品目"
              v-model="search.pinmu"
              style="width: 150px"
              clearable
            >
              <el-option
                v-for="(item, index) in listThreeCategory"
                :label="item.dictName"
                :value="item.dictKey"
                :key="index"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item label="">
          <el-input v-model.trim="search.njFactoryName" placeholder="请输入生产企业" style="width: 100%" :clearable="true"></el-input>
        </el-form-item>
        <el-form-item label="">
          <el-input v-model.trim="search.njFactoryCode" placeholder="请输入出厂编号" style="width: 100%" :clearable="true"></el-input>
        </el-form-item> -->
          <el-form-item label="">
            <el-input
              v-model.trim="search.imei"
              placeholder="请输入监控编号"
              style="width: 100%"
              :clearable="true"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onSubmit">查询</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <el-main style="padding:0;">
      <el-table :data="tableData">
        <el-table-column prop="id" label="序号" width="80" type="index">
        </el-table-column>
        <el-table-column
          prop="county_name"
          label="县（区）"
          :show-overflow-tooltip="true"
          popper-class="tips"
        >
        </el-table-column>
        <el-table-column
          prop="nj_name"
          label="机具品目"
          :show-overflow-tooltip="true"
          popper-class="tips"
        >
        </el-table-column>
        <el-table-column
          prop="nj_factory_code"
          label="出厂编号"
          :show-overflow-tooltip="true"
          popper-class="tips"
        >
        </el-table-column>
        <el-table-column
          prop="imei"
          label="监控编号"
          :show-overflow-tooltip="true"
          popper-class="tips"
        >
        </el-table-column>
        <el-table-column
          prop="enterArea"
          label="当前跨入地区"
          :show-overflow-tooltip="true"
          popper-class="tips"
        >
        </el-table-column>
        <el-table-column
          prop="tranDate"
          label="持续跨区天数"
          :show-overflow-tooltip="true"
          popper-class="tips"
        >
        </el-table-column>
        <el-table-column width="100" prop="address" label="操作">
          <template slot-scope="scope">
            <el-button @click="handleClick(scope.row)" type="text" size="small"
              >查看</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div
        v-if="nodata"
        style="text-align: center;line-height: 70px;font-size: 44px;color:#999;width:100%;height: 600px;line-height: 600px"
      >
        暂无数据
      </div>
    </el-main>
    <div class="block">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="search.currentPage"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="checkcurrentPage"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        style="width:600px;margin: 30px auto"
        v-if="tableData && tableData[0]"
      >
      </el-pagination>
    </div>
    <div v-if="isloading" class="">
      <div class="el-loading-spinner">
        <i class="el-icon-loading"></i>
        <p class="el-loading-text">拼命加载中</p>
      </div>
    </div>
  </div>
</template>
<script>
import Gmap from "../../map/js/fzTianmap.js";
import markerclusterer from "../../map/js/google_markerclusterer.js";
import Http from "../../Serves/net-http.js";
import Api from "../../Serves/net-api.js";
import MONav from "./machineMonitor.vue";
export default {
  components: {
    MONav
  },
  data() {
    return {
      name: "MachineMonitorList",
      formInline: {
        user: "",
        region: ""
      },
      nodata: false,
      isloading: false,
      loading: false, //表格加载状态
      total: 1,
      search: {
        imei: "",
        pinmu: "",
        provCode: this.$store.state.info.provCode,
        countyCode: this.$store.state.info.countyCode,
        // njFactoryCode: '',
        // upAreaLimit: '',
        // downAreaLimit: '',
        currentPage: 1,
        pageSize: 10
      },
      checkcurrentPage: 10,
      listThreeCategory: [],
      tableData: [],
      countyList: [],
      njShow: false,
      itemList: [],
      njTotal: ""
    };
  },
  mounted() {
    if (this.$store.state.info.provCode === '31') {
      this.getCountyList(this.$store.state.info.areaCode)
    }
    this.selectNjTransRegionalNumbers();
    this.getlistThreeCategory();
    this.query();
  },
   beforeRouteLeave (to, from, next) {
    if ((to.path === '/nj/discount_details' && from.fullPath === '/Machine-monitor-list') || (to.path === '/DiscountDetails' && from.fullPath === '/Machine-monitor-list')) {
      from.meta.keepAlive = true
    } else {
      from.meta.keepAlive = false
    }
    next()
  },
  methods: {
    selectNjTransRegionalNumbers() {
      var parmse = {
        provCode: this.search.provCode,
        countyCode: this.search.countyCode,
        pinmu: this.search.pinmu,
        imei: this.search.imei,
        // year: this.search.year,
        currentPage: this.search.currentPage,
        pageSize: this.search.pageSize
      };
      var url = Http.test + "/peasant/selectNjPeasantNums";
      Api.doPost(url, parmse, false, res => {
        if (res.result.length !== 0) {
          this.njShow = true;
          this.itemList = res.result;
          this.njTotal = res.result[0].total;
        }
      });
    },
    getCountyList(value) {
      var url = Http.test + "/area/getCountyOfProvinceForMunicipality";
      Api.doPost(url, { provCode: value }, false, res => {
        this.countyList = res.result;
      });
    },
    // 品目
    getlistThreeCategory() {
      var url = Http.test + "/sysDict/getItemsByType";
      var parmse = {
        provCode: this.search.provCode,
        countyCode: this.search.countyCode
      };
      Api.doPost(
        url,
        parmse,
        true,
        res => {
          this.listThreeCategory = res.result.map(item => {
            if (item) return item;
          });
        },
        doError => {
          console.log(doError);
        }
      );
    },
    // 获取列表数据
    query() {
      var onsearch = {
        provCode: this.search.provCode,
        countyCode: this.search.countyCode,
        pinmu: this.search.pinmu,
        imei: this.search.imei,
        currentPage: this.search.currentPage,
        pageSize: this.search.pageSize
      };
      this.loading = true;
      this.isloading = true;
      var url = Http.test + "/peasant/selectNjPeasantInfo";
      Api.doPost(
        url,
        onsearch,
        false,
        res => {
          this.loading = false;
          this.isloading = false;
          this.tableData = res.result.dataSource;
          this.total = res.result.totalRow;
          if (this.tableData.length == 0) {
            this.nodata = true;
          } else {
            this.nodata = false;
          }
        },
        doError => {
          console.log(doError);
        }
      );
    },
    // 查看
    handleClick(row) {
      if (row.type === 1) {
        this.$router.push({
          name: "NjDiscountDetails",
          params: {
            rowId: row.id,
            imei: row.imei,
            backPath: "/nj/allowance-stock-list"
          }
        });
      } else {
        this.$router.push({
          name: "DiscountDetails",
          params: { imei: row.imei }
        });
      }
    },
    onSubmit() {
      this.nodata = false;
      this.isloading = true;
      this.currentPage = 1;
      this.query();
      this.selectNjTransRegionalNumbers();
    },
    handleSizeChange(val) {
      this.checkcurrentPage = val;
      this.search.currentPage = 1;
      this.query();
    },
    handleCurrentChange(currentPage) {
      this.search.currentPage = currentPage;
      this.query();
    },
    timeFormat(date) {
      if (!date || typeof date === "string") {
        this.error("参数异常，请检查...");
      }
      var y = date.getFullYear() - 1; // 年
      // this.yearValue = y
      var m = date.getMonth() + 1; // 月
      var d = date.getDate(); // 日
      if (m >= 1 && m <= 9) {
        m = "0" + m;
      }
      if (d >= 1 && d <= 9) {
        d = "0" + d;
      }
      return y + "-" + m + "-" + d;
    },
    // 获取去年第一个月
    getFirstDayOfYear(date) {
      date.setDate(1);
      date.setMonth(0);
      return this.timeFormat(date);
    },
    // 获取去年当前月
    getNowFormatDates() {
      var date = new Date();
      var seperator1 = "-";
      var year = date.getFullYear() - 1;
      var month = date.getMonth() + 1;
      var strDate = date.getDate();
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
      }
      // var currentdate = year + seperator1 + month + seperator1 + strDate
      var currentdate =
        year + seperator1 + 12 + seperator1 + this.getLastDay(year, 12);
      return currentdate;
    },
    getLastDay(year, month) {
      var new_year = year; //取当前的年份
      var new_month = month++; //取下一个月的第一天，方便计算（最后一天不固定）
      if (month > 12) {
        new_month -= 12; //月份减
        new_year++; //年份增
      }
      var new_date = new Date(new_year, new_month, 1); //取当年当月中的第一天
      return +new Date(new_date.getTime() - 1000 * 60 * 60 * 24).getDate(); //获取当月最后一天日期
    }
  }
};
</script>
<style scoped>
.contents {
  width: 100%;
  height: 100%;
}
p {
  color: #fff;
}
.el-table {
  width: 98% !important;
  margin: auto;
  color: #fff;
}
.select-block {
  line-height: 40px;
  width: 98%;
  margin-bottom: 10px;
}
.gutter-examples {
  width: 100%;
  height: 110px;
  display: flex;
  /* padding: 24px 0; */
}
.gutter-boxs {
  width: 16.6%;
  height: 75%;
  text-align: center;
  margin-top: 10px;
}
.gutter-boxs:nth-child(1),
.gutter-boxs:nth-child(2),
.gutter-boxs:nth-child(3),
.gutter-boxs:nth-child(4),
.gutter-boxs:nth-child(5) {
  margin-right: 20px;
  border-right: solid 1px #1f3668;
}
.gutter-boxs img {
  margin-bottom: 20px;
}
.cross_title {
  margin-bottom: 20px;
  background: #06135e;
}
.titles {
  width: 100%;
  font-weight: bold;
  font-size: 20px;
  padding-top: 10px;
  margin-left: 20px;
}
.tit {
  font-size: 16px;
}
.tit-num {
  font-size: 30px;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/MachineryDistribution/MachineMonitorList.vue